/**
 * Retrieve a MetaDataStore key
 * @param {Object} state the store state
 * @param {Object} key the key we want from the store
 * @returns {Function} selector function
 */
const selectByKey = (state, key) => state.metaData?.[key];

const selectMarketSwitcherOption = (state) => selectByKey(state, 'marketSwitcherOption') || {};

export const selectMarketSwitcherOptionHeaders = (state) => {
    const switcherOption = selectMarketSwitcherOption(state);

    return switcherOption?.headers;
};

export const selectMarketSwitcherSelectionTypeIds = (state) => {
    const switcherOption = selectMarketSwitcherOption(state);

    return switcherOption?.selection_type_ids || [];
};

export const selectMarketSwitcherSpecialOdds = (state) => {
    const switcherOption = selectMarketSwitcherOption(state);

    return switcherOption?.special_odds_value || null;
};
